import { render, staticRenderFns } from "./ProgramTemplate.vue?vue&type=template&id=795b4823&"
import script from "./ProgramTemplate.vue?vue&type=script&lang=js&"
export * from "./ProgramTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports